import React from 'react';
import classNames from 'classnames';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './Tabs.styles.scss';

type TabsProps = {
  tabs: { path: string; label: string }[];
};

const Tabs = (props: TabsProps) => {
  const { tabs } = props;
  const location = useLocation();

  const { t } = useTranslation();

  return (
    <div className="tabs">
      <div className="tabs__wrapper">
        <div className="tabs__wrapper__list">
          {tabs.map((tab) => (
            <Link
              key={tab.path}
              to={tab.path}
              className={classNames('tabs__wrapper__list__item', {
                'tabs__wrapper__list__item--active':
                  location.pathname === tab.path,
              })}
            >
              {t(tab.label)}
            </Link>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Tabs;
